/**
 * Ad link visits: one record per tab of a landing on /o/<handle> or
 * /o/<handle>/tour, with every query parameter the link carried (any name,
 * so the office can see what an agency's links really send) and the
 * referring site's host. Fire and forget: nothing on the page waits for it,
 * and a failure changes nothing. The API bounds what it keeps (ad-visits.ts).
 */
import { API_BASE } from './api';

const LANDING = /^\/o\/([a-z0-9][a-z0-9-]{0,62})(\/tour)?\/?$/;
const LOGGED_KEY = 'tl_ad_visit_logged';

export function logAdVisit(
  pathname: string = window.location.pathname,
  search: string = window.location.search,
  referrer: string = document.referrer,
): void {
  try {
    const m = LANDING.exec(pathname);
    if (!m) return;
    const path = pathname.replace(/\/$/, '');
    try {
      if (sessionStorage.getItem(LOGGED_KEY) === path) return;
      sessionStorage.setItem(LOGGED_KEY, path);
    } catch {
      // Storage blocked: log anyway, once per page load.
    }
    const params: Record<string, string> = {};
    new URLSearchParams(search).forEach((v, k) => {
      if (!(k in params)) params[k] = v;
    });
    let referrerHost: string | undefined;
    try {
      const host = referrer ? new URL(referrer).hostname : '';
      if (host && host !== window.location.hostname) referrerHost = host.slice(0, 100);
    } catch {
      // An unreadable referrer is left out.
    }
    void fetch(`${API_BASE}/public/tour/${m[1]}/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, params, ...(referrerHost ? { referrerHost } : {}) }),
      keepalive: true,
      credentials: 'omit',
    }).catch(() => undefined);
  } catch {
    // Never let the log touch the page.
  }
}
